import httpClient from "../httpClient"
import BOOSTER_COUPON_END_POINT from "./BOOSTER_COUPON_END_POINT"

const boosterCouponApi = {
  async valid(code: string) {
    return httpClient.get<"">(BOOSTER_COUPON_END_POINT.VALID, { pathParams: { code } })
  },
} as const

export default boosterCouponApi
